import { MetroImage } from 'components/city-blocks/metro-image';
import { UnderlineLabel } from 'components/dynamic-content/button';
import React from 'react';
import { NoFollowLink } from 'shared/no-follow-link';
import { RegionInfoFragment } from 'utils/gqlReactTypings.generated.d';
import { encodeRegionPageHref } from 'utils/urls';

interface IProps {
  className?: string;
  region: RegionInfoFragment;
}

export const RegionCard: React.FC<IProps> = ({ className, region }) => {
  const href = encodeRegionPageHref(region);

  return (
    <NoFollowLink
      href={href}
      className={`outline-red-50 inline-flex h-56 w-48 flex-col items-center justify-start rounded-lg px-4 pb-4 pt-3 shadow-sm outline outline-1 outline-offset-[-1px] ${className}`}>
      {/* Metro Image Container */}
      <div className='flex h-32 w-24 max-w-48 flex-col items-start justify-start pb-4'>
        <div className='relative size-24 overflow-hidden'>
          <MetroImage region={region} className='size-24' />
        </div>
      </div>

      {/* Content */}
      <div className='flex w-full flex-col items-center justify-start'>
        <div className='flex flex-col items-start justify-start pb-2'>
          <div className='text-red-950 justify-center text-2xl font-bold leading-9'>{region.displayName}</div>
        </div>
        <UnderlineLabel text={'Explore'} className='w-full' />
      </div>
    </NoFollowLink>
  );
};
